var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pe-renderer',{attrs:{"imgErrorTemplate":_vm.imgErrorTemplate,"imgPdf":_vm.imgPdf}})
}
var staticRenderFns = []

export { render, staticRenderFns }